const newRenderCartGoal = (cartGoalIndex) => {
  if (document.querySelectorAll(window.tlCartGoalEmbed.ROOT_SELECTOR_ELEMENT).length || window.tlCartGoalEmbed.cartDrawDisplay.selector || window.tlCartGoalEmbed.cartDisplay.selector) {
      let milestonesHTMLInCartDrawer = ``;
      let closestGoal = -1;
      let marginValues = window.tlCartGoalEmbed.getCartGoalsMarginValues();
      window.tlCartGoalEmbed.milestones.map((milestone, index) => {
          if (closestGoal === -1 && milestone.cart_value > window.tlCartGoalEmbed.cartTotal) {
              closestGoal = index;
          }
          const [milestoneTitle, beforeAchieve, afterAchieve, imgSrc] = window.tlCartGoalEmbed.getRewardTitleByType(milestone);
        
          milestonesHTMLInCartDrawer += `
              <div class="tl__cart-goal__goal-check-point__drawer" 
                  style="margin-left: ${marginValues[index]}%;
                  z-index: 1;
                  border-color: ${(() => window.tlCartGoalEmbed.cartTotal >= milestone.cart_value ? "var(--tl__cart-goal__filled-bar-color)" : "black")()}"
              >
                  <p class="tl__cart-goal__goal-check-point-value" 
                      style="color: var(--tl__cart-goal__milestone-label-color); 
                      visibility: ${index === closestGoal ? "visible" : ""}"
                  >
                      <span class="money">${window.tlCartGoalEmbed.formatMoney(milestone.cart_value * 100, window.tlCartGoalEmbed.currencyFormat, window.tlCartGoalEmbed.currencyDisplay)}</span>
                  </p>
                  <img style = "filter: ${(() => window.tlCartGoalEmbed.cartTotal >= milestone.cart_value 
                      ? "var(--tl__cart-goal__filter-bar-color)" 
                      : "invert(0%) sepia(0%) saturate(3%) hue-rotate(177deg) brightness(100%) contrast(100%)")()}"
                      alt="tl-cart-goal" class="tl__cart-goal__milestone-image" src="${imgSrc}"/>
                  <p class="tl__cart-goal__goal-check-point-title" 
                      style="min-height: 25px; color: var(--tl__cart-goal__milestone-label-color); 
                      visibility: ${index === closestGoal ? "visible" : ""}"
                  >${milestoneTitle}</p>
              </div>
          `;
      });
      let trademarkHTMLInCartDrawer = window.tlCartGoalEmbed.showTrademark 
          ? `
          <p
              style="
                  display: block !important;
                  visibility: visible !important;
                  opacity: 1 !important;
                  position: static !important;
                  transform: none !important;
                  clip-path: none !important;
                  overflow: visible !important;
                  width: auto !important;
                  height: auto !important;
                  max-width: none !important;
                  max-height: none !important;
                  background: none !important;
                  color: #000 !important;
                  font-size: 12px !important;
                  text-align: center !important;
                  margin: 0 !important;
              "
          >
              Powered by 
              <a
                  href="https://apps.shopify.com/salepify?utm_source=powered&utm_medium=merchant-store&utm_campaign=partnership2024" 
                  target="_blank"
                  style="
                      display: inline !important;
                      visibility: visible !important;
                      opacity: 1 !important;
                      position: static !important;
                      transform: none !important;
                      clip-path: none !important;
                      overflow: visible !important;
                      width: auto !important;
                      height: auto !important;
                      max-width: none !important;
                      max-height: none !important;
                      background: none !important;
                      color: #000 !important;
                      font-size: 12px !important;
                      text-align: center !important;
                      cursor: pointer !important;
                      text-decoration: underline !important;
                  "
              >
                  Salepify App
              </a>
          </p>
          ` : "";      

      const isOnArabic = window.location.href.includes("/ar/");
    
      let cartGoalHTMLInCartDrawer = `
          <div class="tl__cart-goal__container__drawer ${isOnArabic ? 'tl__cart-goal__container__drawer--flipped-horizontally' : ''}">
              <p class="tl__cart-goal__reward-description__drawer">${window.tlCartGoalEmbed.getLeftAmountText(window.tlCartGoalEmbed.milestones[closestGoal])}</p>
              <div class="tl__cart-goal__goal-container__drawer">
                  <div class="tl__cart-goal__goal-process__drawer" style="display: block; width: ${window.tlCartGoalEmbed.getProcessBarWidth()}%"></div>
                  ${milestonesHTMLInCartDrawer}
              </div>
              <hr style="margin: 5px 0px; width: 100%; height: 1px"/>
              <div class="tl__cart-goal__free-gift-container-${cartGoalIndex}" style="width: 100%; color: #303030">
                  ${window.tlCartGoalEmbed.renderReward(cartGoalIndex)}
              </div>
              ${trademarkHTMLInCartDrawer}
          </div>
      `;

      return cartGoalHTMLInCartDrawer;
  }
}

const newRenderReward = (cartGoalIndex) => {
  let tlCartGoalLocalStorage = JSON.parse(localStorage.getItem(LOCAL_STORAGE));

  let freeShippingHTML = "";
  let discountHTML = "";
  let giftsHTML = "";

  if(!window.tlCartGoalEmbed.sectionRewardStyle.hide_claim_reward || !window.tlCartGoalEmbed.cartGoal.auto_add_reward) {
  if (window.tlCartGoalEmbed.passedMilestone.freeShipping !== -1) {
      const aplliedFreeShipping = tlCartGoalLocalStorage.freeShipping !== -1;
      const milestone = window.tlCartGoalEmbed.milestones[window.tlCartGoalEmbed.passedMilestone.freeShipping];
      const [title, beforeAchieve, afterAchieve] = window.tlCartGoalEmbed.getRewardTitleByType(milestone);
      freeShippingHTML += `
          <div style="display: flex; width: 100%;justify-content: space-between;align-items:center">
              <div>
                  <p style="margin: 0px; padding: 0px; font-weight: bold; font-size: 14px">${title}</p>
                  <p style="margin: 0px; padding: 0px; font-size: 12px; margin-bottom: 5px">${afterAchieve}</p>
              </div>
              <div style="width: 40%;text-align: center;font-size: 13px; display: flex; justify-content: end">
              `+`
              ${
                  window.tlCartGoalEmbed.cartGoal.auto_add_reward ? (aplliedFreeShipping ?
                  `<div
                      class="tl-cart-goal-apply-free-shipping-btn__cart-drawer"
                      style="width: 100%;background: ${window.tlCartGoalEmbed.sectionRewardStyle.button_selected_color};
                      color: white;font-size: 14px;border-radius: 5px;cursor: pointer;max-width: 120px;"
                      onclick=""
                  >
                      ${window.tlCartGoalEmbed.translation.auto_apply_btn.shipping_discount}
                  </div>` : ``)
                  :
                  (`<div 
                      class="tl-cart-goal-apply-free-shipping-btn__cart-drawer"
                      style="width: 100%;background: ${!aplliedFreeShipping ? "var(--tl__cart-goal__section-reward__button-color)" : "#d9cdcd"};color: white;font-size: 14px;border-radius: 5px;cursor: pointer;max-width: 120px;"
                      onclick="${!aplliedFreeShipping ? `window.tlCartGoalEmbed.handleApplyFreeShippingCode()` : ''}"
                  >
                      ${!aplliedFreeShipping 
                          ? `${window.tlCartGoalEmbed.translation.manual_apply_btn.shipping_discount.before_apply}` 
                          : `${window.tlCartGoalEmbed.translation.manual_apply_btn.shipping_discount.after_apply}`
                      }
                  </div>`)
              }
              `+`
              </div>
          </div>
      `;
  }
  if (window.tlCartGoalEmbed.passedMilestone.discount !== -1) {
      const aplliedCartDiscount = tlCartGoalLocalStorage.discount !== -1;
      const milestone = window.tlCartGoalEmbed.milestones[window.tlCartGoalEmbed.passedMilestone.discount];
      const [title, beforeAchieve, afterAchieve] = window.tlCartGoalEmbed.getRewardTitleByType(milestone);
      discountHTML += `
          <div style="display: flex; width: 100%;justify-content: space-between;align-items:center">
              <div>
                  <p style="margin: 0px; padding: 0px; font-weight: bold; font-size: 14px">${title}</p>
                  <p style="margin: 0px; padding: 0px; font-size: 12px; margin-bottom: 5px">${afterAchieve}</p>
              </div>
              <div style="width: 40%;text-align: center;font-size: 13px; display: flex; justify-content: end">
              `+`
              ${
                  window.tlCartGoalEmbed.cartGoal.auto_add_reward ? (aplliedCartDiscount ?
                  `<div 
                      class="tl-cart-goal-apply-discount-code-btn__cart-drawer"
                      style="width: 100%;background: ${window.tlCartGoalEmbed.sectionRewardStyle.button_selected_color};color: white;font-size: 14px;border-radius: 5px;cursor: pointer;max-width: 120px;"
                      onclick="">
                          ${window.tlCartGoalEmbed.translation.auto_apply_btn.order_discount}
                      </div>` :``)
                  :
                  (`<div 
                      class="tl-cart-goal-apply-discount-code-btn__cart-drawer"
                      style="width: 100%;background: ${!aplliedCartDiscount ? "var(--tl__cart-goal__section-reward__button-color)" : "#d9cdcd"};color: white;font-size: 14px;border-radius: 5px;cursor: pointer;max-width: 120px;"
                      onclick="${!aplliedCartDiscount ? `window.tlCartGoalEmbed.handleApplyDiscountCode()` : ''}"
                      >
                        ${!aplliedCartDiscount 
                          ? `${window.tlCartGoalEmbed.translation.manual_apply_btn.order_discount.before_apply}` 
                          : `${window.tlCartGoalEmbed.translation.manual_apply_btn.order_discount.after_apply}`
                      }
                  </div>`)
              }
              `+`
              </div>
          </div>
          <hr style="margin: 5px 0px; width: 100%; height: 1px"/>
      `;
  }
  if (window.tlCartGoalEmbed.passedMilestone.gift !== -1) {
      const passedFreeGift = window.tlCartGoalEmbed.passedMilestone.gift;
      const aplliedFreeGift = tlCartGoalLocalStorage.gift >= window.tlCartGoalEmbed.passedMilestone.gift;
      
      let giftItemHTML = "";
      let giftVariants = window.tlCartGoalEmbed.gifts[window.tlCartGoalEmbed.passedMilestone.indexOfPassedFreeGift];
      giftVariants.map((variant, variantIndex) => {
          giftItemHTML += `
              <div class="tl__cart-goal__free-gift-reward-body">
                  <div style="display: flex; gap: 5px">
                      <img class="tl__cart-goal__product-image" src="${variant.featured_image.src || variant.featured_image}" alt="product-image"/>
                      <div class="tl__cart-goal__product-image-info">
                          <p>${variant.name}</p>
                          <span class="money"><del>${window.tlCartGoalEmbed.formatMoney(variant.price, window.tlCartGoalEmbed.cartGoal.currency_format, window.tlCartGoalEmbed.cartGoal.currency_display)}</del></span>
                          <span>${window.tlCartGoalEmbed.translation.gift_modal.free_text_content}</span>
                          <span>${window.tlCartGoalEmbed.milestones[window.tlCartGoalEmbed.passedMilestone.gift].specific_quantity ? "x" + variant.specificQuantity + `${variant.specificQuantity > 1 ? " items": " item"}` : "x1 item"}</span>
                      </div>
                  </div>
                  <div class="tl__cart-goal__check-box tl__cart-goal__check-box-${passedFreeGift} tl__cart-goal__check-box-${passedFreeGift}-${variantIndex}"
                  onClick="window.tlCartGoalEmbed.handleChangeGift(${passedFreeGift}, ${variantIndex})" tl__cart-goal_data_id=${variant.id}></div>
              </div>
          `;
      })

      const milestone = window.tlCartGoalEmbed.milestones[window.tlCartGoalEmbed.passedMilestone.gift];
      const [title, beforeAchieve, afterAchieve] = window.tlCartGoalEmbed.getRewardTitleByType(milestone);
      giftsHTML += `
          <div style="display: flex; width: 100%;justify-content: space-between;">
              <div style="width: 60%">
                  <p style="margin: 0px; padding: 0px; font-weight: bold; font-size: 14px">${title}</p>
                  <p style="margin: 0px; padding: 0px; font-size: 12px; margin-bottom: 5px">${afterAchieve}</p>
              </div>
              `+`
              ${(window.tlCartGoalEmbed.cartGoal.auto_add_reward && giftVariants.length) ? (aplliedFreeGift ? 
              `<div style="background: ${window.tlCartGoalEmbed.sectionRewardStyle.button_selected_color}" class="tl__cart-goal__gift-noti">
                  ${window.tlCartGoalEmbed.translation.auto_apply_btn.gift}
              </div>`:`` )
              :
              (`<div style="background: ${aplliedFreeGift ? "var(--tl__cart-goal__section-reward__button-selected-color)" : "var(--tl__cart-goal__section-reward__button-color)"}" class="tl__cart-goal__gift-noti" onclick="window.tlCartGoalEmbed.toggleGifts(${cartGoalIndex})">
                  <span>
                      ${aplliedFreeGift 
                      ? `${window.tlCartGoalEmbed.translation.manual_apply_btn.gift.after_apply}` 
                      : `${window.tlCartGoalEmbed.translation.manual_apply_btn.gift.before_apply}`}
                  </span>
              </div>`)
              }
              `+`
          </div>
          <div class="tl__cart-goal__gift-modal-${cartGoalIndex}">
          ${
              giftVariants.length !== 0
                  ? `<div class="tl__cart-goal__list-gifts tl__cart-goal__list-gifts-${passedFreeGift}">
                        <span style="font-weight: 500">${window.tlCartGoalEmbed.translation.gift_modal.title.replace(
                            "{{amount}}",
                            `${window.tlCartGoalEmbed.milestones[passedFreeGift].reward_value}`,
                        )} <span class="tl_selected_quantity"></span></span>
                        <div style="max-height: 300px; overflow-y: auto; width: 100%">
                        ${giftItemHTML}
                        </div>
                        <div id="salepify-cart-goal-block-error"></div>
                        <div style="display: flex; width: 100%;height: 60px">
                            <div class="tl__cart-goal__button-cancel-gift" onclick="window.tlCartGoalEmbed.toggleGifts(${cartGoalIndex}, false)">
                              ${window.tlCartGoalEmbed.translation.gift_modal.cancel_btn}
                            </div>
                            <div class="tl__cart-goal__button-add-gift" onclick="(()=>{window.tlCartGoalEmbed.handleAddtoCart(${passedFreeGift}, ${cartGoalIndex}) ; ${window.tlCartGoalEmbed.isClickButtonConfirm = true}})()">
                              ${window.tlCartGoalEmbed.translation.gift_modal.confirm_btn}
                            </div>
                        </div>
                    </div>`
                  : `<div class="tl__cart-goal__list-gifts">
                          <span style="font-weight: 600">Sorry, but there's no gift available</span>
                          <div style="display: flex; width: 100%;height: 60px">
                              <div class="tl__cart-goal__button-cancel-gift" style="width: 100%;" onclick="window.tlCartGoalEmbed.toggleGifts(${cartGoalIndex}, false)">
                                  ${window.tlCartGoalEmbed.translation.gift_modal.cancel_btn}
                              </div>
                          </div>
                    </div>`
          }
          </div>
          <hr style="margin: 5px 0px; width: 100%; height: 1px"/>
      `;
  }
  }
  return `
      ${giftsHTML}
      ${discountHTML}
      ${freeShippingHTML}
  `;
}

const newReplaceVariables = (string, milestone, title) => {
    const cartValue = milestone.cart_value;
    return string
        .replace(/{{discount}}/g, `${cartValue} 
            ${
                milestone.discount_type === "percentage" ?
                    `${cartValue}%` :
                    `<span class="money">${window.tlCartGoalEmbed.formatMoney(cartValue * 100, window.tlCartGoalEmbed.currencyFormat, window.tlCartGoalEmbed.currencyDisplay)}</span>`
            }`  
        )
        .replace(/{{amount}}/g, `<span class="money">${window.tlCartGoalEmbed.formatMoney((cartValue - window.tlCartGoalEmbed.cartTotal) * 100, window.tlCartGoalEmbed.currencyFormat, window.tlCartGoalEmbed.currencyDisplay)}</span>`)
        .replace(/{{title}}/g, title)
}

const overwriteRenderCartGoal = () => {
  if (window.tlCartGoalEmbed) {
    clearInterval(intervalId);

    window.tlCartGoalEmbed.renderCartGoal = newRenderCartGoal;
    window.tlCartGoalEmbed.renderReward = newRenderReward;
    window.tlCartGoalEmbed.replaceVariables = newReplaceVariables;
  }
}

const intervalId = setInterval(overwriteRenderCartGoal, 50);
setTimeout(() => {
  clearInterval(intervalId);
}, 3000);